import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { addGalleryImage, deleteGalleryImage, getAllGalleryImages } from ".";

const useGetAllGalleryImages = () => {
  return useQuery({
    queryKey: ["gallery-images"],
    queryFn: getAllGalleryImages,
  });
};

const useAddGalleryImage = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: addGalleryImage,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["gallery-images"] });
    },
  });
};

const useDeleteGalleryImage = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: deleteGalleryImage,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["gallery-images"] });
    },
  });
};
export { useGetAllGalleryImages, useAddGalleryImage, useDeleteGalleryImage };
